import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import WarrantyTrigger from "./WarrantyTrigger";
import WarrantyBottomSheet from "./WarrantyBottomSheet";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import MobileWarrantyPromoCode from "@/pages/checkout/warranty/MobileWarrantyPromoCode";
export default function WarrantySection(_ref) {
  var _checkoutOrderV2$sect, _warrantySection$item, _warrantyItem$selecte, _warrantyItem$selecte2, _warrantyData$items5, _warrantyData$items$f4;
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    _ref$orderType = _ref.orderType,
    orderType = _ref$orderType === void 0 ? "amwal" : _ref$orderType,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? "checkout" : _ref$referralLocation,
    onWarrantyChange = _ref.onWarrantyChange,
    warranty_promo_code_enabled = _ref.warranty_promo_code_enabled;
  var _useSession = useSession(),
    user = _useSession.user;
  var warrantySection = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : _checkoutOrderV2$sect.find(function (section) {
    return section.type === "warranty_list";
  });
  var warrantyItem = warrantySection === null || warrantySection === void 0 ? void 0 : (_warrantySection$item = warrantySection.items) === null || _warrantySection$item === void 0 ? void 0 : _warrantySection$item[0];
  var warrantyData = warrantyItem ? {
    selected: warrantyItem.selected ? _objectSpread(_objectSpread({}, warrantyItem.selected), {}, {
      price: {
        current: warrantyItem.selected.price.current,
        original: (_warrantyItem$selecte = warrantyItem.selected.price.original) !== null && _warrantyItem$selecte !== void 0 ? _warrantyItem$selecte : 0,
        current_formatted: warrantyItem.selected.price.current_formatted,
        original_formatted: (_warrantyItem$selecte2 = warrantyItem.selected.price.original_formatted) !== null && _warrantyItem$selecte2 !== void 0 ? _warrantyItem$selecte2 : ""
      }
    }) : null,
    items: (warrantyItem.warranty_items || []).map(function (item) {
      var _item$price$original, _item$price$original_;
      return {
        id: item.id,
        title: item.title,
        badge: item.badge,
        subtitle: item.subtitle,
        description: item.description,
        price: {
          current: item.price.current,
          original: (_item$price$original = item.price.original) !== null && _item$price$original !== void 0 ? _item$price$original : 0,
          current_formatted: item.price.current_formatted,
          original_formatted: (_item$price$original_ = item.price.original_formatted) !== null && _item$price$original_ !== void 0 ? _item$price$original_ : ""
        },
        selected: item.selected,
        is_default: item.is_default,
        years: item.years,
        years_in_months: item.years_in_months,
        kilometers: item.kilometers
      };
    })
  } : null;
  var _useState = useState(false),
    showBottomSheet = _useState[0],
    setShowBottomSheet = _useState[1];
  var _useState2 = useState(function () {
      var _warrantyData$items$f, _warrantyData$items, _warrantyData$items$f2, _warrantyData$items2, _warrantyData$items2$;
      return (_warrantyData$items$f = warrantyData === null || warrantyData === void 0 ? void 0 : (_warrantyData$items = warrantyData.items) === null || _warrantyData$items === void 0 ? void 0 : (_warrantyData$items$f2 = _warrantyData$items.find(function (i) {
        return i.selected;
      })) === null || _warrantyData$items$f2 === void 0 ? void 0 : _warrantyData$items$f2.id) !== null && _warrantyData$items$f !== void 0 ? _warrantyData$items$f : warrantyData === null || warrantyData === void 0 ? void 0 : (_warrantyData$items2 = warrantyData.items) === null || _warrantyData$items2 === void 0 ? void 0 : (_warrantyData$items2$ = _warrantyData$items2[0]) === null || _warrantyData$items2$ === void 0 ? void 0 : _warrantyData$items2$.id;
    }),
    selectedId = _useState2[0],
    setSelectedId = _useState2[1];

  // Sync with the server-reported selection whenever the order is re-fetched.
  // This handles cases like promo-code reset or tab switching where the API
  // might return the default (free) warranty. We only update if the server
  // reports a *different* selected id than what we already have locally.
  useEffect(function () {
    var _warrantyData$items$f3, _warrantyData$items3, _warrantyData$items3$, _warrantyData$items4, _warrantyData$items4$;
    var serverSelectedId = (_warrantyData$items$f3 = warrantyData === null || warrantyData === void 0 ? void 0 : (_warrantyData$items3 = warrantyData.items) === null || _warrantyData$items3 === void 0 ? void 0 : (_warrantyData$items3$ = _warrantyData$items3.find(function (i) {
      return i.selected;
    })) === null || _warrantyData$items3$ === void 0 ? void 0 : _warrantyData$items3$.id) !== null && _warrantyData$items$f3 !== void 0 ? _warrantyData$items$f3 : warrantyData === null || warrantyData === void 0 ? void 0 : (_warrantyData$items4 = warrantyData.items) === null || _warrantyData$items4 === void 0 ? void 0 : (_warrantyData$items4$ = _warrantyData$items4[0]) === null || _warrantyData$items4$ === void 0 ? void 0 : _warrantyData$items4$.id;
    if (serverSelectedId != null && serverSelectedId !== selectedId) {
      setSelectedId(serverSelectedId);
    }
  }, [warrantyData]);

  // When a warranty promo code is active, show the promo banner immediately
  // BEFORE the warrantyData guard — the promo banner doesn't need items[]
  if (warranty_promo_code_enabled) {
    return /*#__PURE__*/React.createElement(MobileWarrantyPromoCode, null);
  }
  if (!(warrantyData !== null && warrantyData !== void 0 && (_warrantyData$items5 = warrantyData.items) !== null && _warrantyData$items5 !== void 0 && _warrantyData$items5.length)) return null;
  var selectedItem = (_warrantyData$items$f4 = warrantyData.items.find(function (i) {
    return i.id === selectedId;
  })) !== null && _warrantyData$items$f4 !== void 0 ? _warrantyData$items$f4 : warrantyData.items[0];
  var baseEventParams = {
    order_id: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id,
    referral_location: referralLocation,
    order_type: orderType
  };
  var handleOpen = function handleOpen() {
    setShowBottomSheet(true);
    trackEvents("warranty_list_opened", baseEventParams);
  };
  var handleConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
      var _warrantyData$items6, _warrantyData$items6$;
      var years;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setSelectedId(id);
            setShowBottomSheet(false);
            _context.n = 1;
            return onWarrantyChange === null || onWarrantyChange === void 0 ? void 0 : onWarrantyChange(id);
          case 1:
            years = warrantyData === null || warrantyData === void 0 ? void 0 : (_warrantyData$items6 = warrantyData.items) === null || _warrantyData$items6 === void 0 ? void 0 : (_warrantyData$items6$ = _warrantyData$items6.find(function (ele) {
              return (ele === null || ele === void 0 ? void 0 : ele.id) == id;
            })) === null || _warrantyData$items6$ === void 0 ? void 0 : _warrantyData$items6$.years;
            trackEvents("warranty_selected", _objectSpread(_objectSpread({}, baseEventParams), {}, {
              selected_warranty: years
            }));
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleConfirm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (warrantyData.items.length <= 1) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(WarrantyTrigger, {
    data: warrantyData,
    selectedItem: selectedItem,
    onClick: handleOpen
  })), /*#__PURE__*/React.createElement(WarrantyBottomSheet, {
    data: warrantyData,
    open: showBottomSheet,
    selectedId: selectedId,
    onSelect: setSelectedId,
    onClose: function onClose() {
      return setShowBottomSheet(false);
    },
    onConfirm: handleConfirm
  }));
}